<div class="back-and-name-banner flex gap-4 align-items-center mb-3" data-cy="back-and-name-banner">
  <button class="!min-w-12" cue-button size="small" (click)="requestClose.emit()" data-cy="back-button">
    <cue-icon [icon]="ICONS.cueArrowFullLeft" />
  </button>

  <h2 class="m-0 filters-title">
    {{ translation.navigation.filters | transloco }}
  </h2>
  <button class="confirm-btn" cue-button size="small" (click)="requestClose.emit()" data-cy="navigation-filter-confirm">
    <cue-icon [icon]="ICONS.cueCheck" />
    {{ translation.navigation.confirmFilters | transloco }}
  </button>
</div>
<div class="main-filter-container">
  @if (onlyResourceItemList?.length > 0) {
    <div class="title-with-clear-container">
      <p class="text-lg font-bold py-2 m-0">
        {{ translation.navigation.typesFilters | transloco }}
      </p>
      @if (currentFilter().selectedResourceTypeIdList?.length > 0) {
        <button class="filter-type-btn" size="nano" [link]="true" cue-button (click)="clearTypeFilter()">
          <cue-icon [icon]="ICONS.cueClose" />
          {{ translation.navigation.clearTypeFilter | transloco }}
        </button>
      }
    </div>
  }

  <div class="filter-columns" data-cy="start-target-filter-buttons">
    @for (item of onlyResourceItemList; track item) {
      <button
        cue-toggle-button
        [attr.data-cy]="'navigation-filter-resource-type-' + item.resourceTypeId"
        [active]="getSelectedResourceIndex(item.resourceTypeId) > -1"
        (click)="addRemoveResourceFromFilter(item.resourceTypeId)"
        [variant]="'with-image'"
      >
        @if (!!item.iconUrl) {
          <img [src]="item.iconUrl" class="w-5 h-5" />
        }
        <span class="text">{{ item.name | localizedString }}</span>
      </button>
    }
  </div>

  @if (onlyCategoryItemList?.length > 0) {
    <div class="title-with-clear-container mt-2">
      <p class="text-lg font-bold py-2 m-0">
        {{ translation.navigation.categoriesFilters | transloco }}
      </p>
      @if (currentFilter().selectedCategoryIdList?.length > 0) {
        <button class="filter-type-btn" size="nano" [link]="true" cue-button (click)="clearCategoryFilter()">
          <cue-icon [icon]="ICONS.cueClose" />
          {{ translation.navigation.clearCategoryFilter | transloco }}
        </button>
      }
    </div>
  }

  <div class="filter-columns">
    @for (item of onlyCategoryItemList; track item) {
      <button
        cue-toggle-button
        [attr.data-cy]="'navigation-filter-category-' + item.qrCategoryId"
        [active]="getSelectedCategoryIndex(item.qrCategoryId) > -1"
        (click)="addRemoveCategoryFromFilter(item.qrCategoryId)"
        [variant]="'with-image'"
        data-cy="start-target-filter-columns"
      >
        @if (item.iconUrl !== null) {
          <img [src]="item.iconUrl" class="w-5 h-5" />
        }
        <span class="text">{{ item.name | localizedString }}</span>
      </button>
    }
  </div>
  <hr class="my-2" />
  @if (availableAreaList()?.length > 0) {
    <div class="area-container">
      <div class="title-with-clear-container">
        <p class="text-lg font-bold py-2">
          {{ translation.navigation.areaFilters | transloco }}
        </p>
        @if (currentFilter().selectedAreaIdList?.length > 0) {
          <button class="filter-type-btn" size="nano" [link]="true" cue-button (click)="clearAreaFilter()">
            <cue-icon [icon]="ICONS.cueClose" />
            {{ translation.navigation.clearAreaFilter | transloco }}
          </button>
        }
      </div>
      <assist-area-tree
        [openAll]="true"
        (selectionChanged)="selectedAreaIdChanged($event)"
        [selection]="currentFilter()?.selectedAreaIdList"
        [data]="availableAreaList()"
      />
    </div>
  }
</div>
<!--<div class="filter-confirm-buttons">
        <button [size]="isKioskMode ? 'default' : 'small'" cue-button [outlined]="true" (click)="requestClose.emit()">
            <cue-icon [icon]="ICONS.cueClose"></cue-icon>
            {{ translation.navigation.cancelFilters | transloco }}
        </button>
        <button class="confirm-btn" cue-button size="small" (click)="confirmFilter.emit(currentFilter)">
        <cue-icon [icon]="ICONS.cueCheck"></cue-icon>
        {{ translation.navigation.confirmFilters | transloco }}
    </button>
</div>-->
